module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--06.930eb1ef.png";